import { render, staticRenderFns } from "./x3-order-detail.vue?vue&type=template&id=53f8e79a&scoped=true&"
import script from "./x3-order-detail.vue?vue&type=script&lang=js&"
export * from "./x3-order-detail.vue?vue&type=script&lang=js&"
import style0 from "./x3-order-detail.vue?vue&type=style&index=0&id=53f8e79a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f8e79a",
  null
  
)

export default component.exports